import Modal from '@Components/Shared/Modals/Modal';
import TranslationText from '@Components/Utilities/TranslationText';
import translator from '@Components/Utilities/Translator';

const EmailAlertDeleteConfirmationModal = (props) => {
    return (
        <Modal containerClassName='alert-modal'>
            <Modal.Header onClose={props.onClose}>
                <div className="top-row">
                    <Modal.Title headingClassName='show-all-modal-title'>
                        <TranslationText tKey='sandhills.tradesites.mvc.deletealert' />
                    </Modal.Title></div>
            </Modal.Header>
            <Modal.Body>
                <p id='description-label' className='hidden'>Email Alert {props.message} removed</p>
                <p>{props.message}</p>
                <input type='button' className='button ts-button' value={translator.translate('sandhills.delete')} onClick={props.submit} />
                <input type='button' className='button ts-button cancel-button' value={translator.translate('sandhills.cancel')} onClick={props.onClose} />
            </Modal.Body>
        </Modal>
    );
}

export default EmailAlertDeleteConfirmationModal;